export default __webpack_public_path__ + "static/media/diagram.90e29832.svg";